// extracted by mini-css-extract-plugin
module.exports = {"blockTestAcessMessage":"test-access-message_blockTestAcessMessage__35uRy","text":"test-access-message_text__PVItm"};